import React, { useState, useEffect } from 'react';
import Image, { ImageProps as NextImgProps } from 'next/image';
import { Parallax } from 'react-scroll-parallax';
import { useMedia } from 'react-use';
import ImageModel from '../../../models/image';
import styles from './imageWrapper.module.scss';
import breakpoints from '../../../constants/break-points';
import { generateBlurDataURL } from '../../../helpers/image-placeholders';

interface ImageProps extends ImageModel {
  layout?: NextImgProps['layout'];
  parallax?: boolean;
  style?: React.CSSProperties;
}

export default ({
  image,
  mobileImage,
  strict,
  fit,
  scrollSpeed,
  position,
  parallax = true,
  layout = 'fill',
  style
}: ImageProps) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.md}px)`);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile]);

  let media;
  if (!strict && image) {
    media = mobile && mobileImage ? mobileImage : image;
  } else if (strict && mobile && mobileImage) {
    media = mobileImage;
  } else if (strict && !mobile && image) {
    media = image;
  } else return null;

  const imageElement = (
    <Image
      placeholder="blur"
      alt={media.alt}
      src={media.src}
      layout={layout}
      objectFit={fit}
      objectPosition={position}
      blurDataURL={generateBlurDataURL(media.src)}
      {...(layout !== 'fill' && { width: media.width, height: media.height })}
    />
  );

  return parallax ? (
    <Parallax className={styles.image} speed={scrollSpeed} style={style}>
      {imageElement}
    </Parallax>
  ) : (
    imageElement
  );
};
